import checkSoldOut from "./checkSoldOut";

/**
 * Check if an item is available for selection/purchase
 * Validates both item-level AND category-level availability
 *
 * @param {Object} item - Item object with status fields and category_code
 * @param {Array} storeAvailability - Store availability data including categories (avl_type: 'C' and 'I')
 * @returns {boolean} - true if item AND its category are both available
 */
const checkItemAvailable = (item, storeAvailability) => {
  console.log("🔍 [checkItemAvailable] Checking item:", {
    item_no: item?.item_no,
    item_name: item?.item_name,
    category_code: item?.category_code,
    is_soldout: item?.is_soldout,
    is_emenu_disable: item?.is_emenu_disable,
    is_avl_limit_check: item?.is_avl_limit_check,
    bal_qty: item?.bal_qty,
  });

  // Check 1: Item-level availability using existing checkSoldOut utility
  const isItemSoldOut = checkSoldOut(item);
  console.log("📦 [Item-Level Check]:", {
    isSoldOut: isItemSoldOut,
    result: isItemSoldOut ? "❌ UNAVAILABLE" : "✅ Available",
  });

  if (isItemSoldOut) {
    console.log("⛔ Item failed item-level check - UNAVAILABLE");
    return false;
  }

  // Check 2: Category-level availability
  if (!storeAvailability || !Array.isArray(storeAvailability)) {
    console.log("⚠️ No store availability data - assuming available");
    return true;
  }

  // Find the category status for this item
  const categoryStatus = storeAvailability.find(
    (record) =>
      record.avl_type === "C" &&
      record.item_category === item.category_code
  );

  console.log("📂 [Category-Level Check]:", {
    category: item?.category_code,
    categoryFound: !!categoryStatus,
    categoryStatus: categoryStatus
      ? {
          is_emenu_disable: categoryStatus.is_emenu_disable,
          is_soldout: categoryStatus.is_soldout,
        }
      : "Category not found in availability data",
  });

  // If category exists and is disabled or sold out, item is unavailable
  if (categoryStatus) {
    if (
      categoryStatus.is_emenu_disable === "Y" ||
      categoryStatus.is_soldout === "Y"
    ) {
      console.log("⛔ Category is disabled/soldout - Item UNAVAILABLE");
      console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
      return false;
    }
  }

  // Both item and category are available
  console.log("✅ FINAL RESULT: Item AVAILABLE (both item & category passed)");
  console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
  return true;
};

export default checkItemAvailable;
